import { Component, HostBinding, OnInit } from '@angular/core';
import { SessionService } from '../shared/services/session/session.service';
import { Language } from '../shared/domain/language';
import { SystemConfig } from '../shared/config/system-config';
import { languageFactory } from '../app.module';
import { TranslationService } from '../shared/services/translation/translation.service';

@Component({
  selector: 'vit-punter-bar',
  templateUrl: './punter-bar.component.html',
  styleUrls: ['./punter-bar.component.scss']
})
export class PunterBarComponent implements OnInit {

  @HostBinding('class.no-user') get noUserClass(): boolean {
    return !this.sessionService.punter;
  }

  selectedLanguage: Language;
  showLanguageMenu: boolean = false;
  flagsPath = SystemConfig.Asset.FLAGS;

  constructor(public sessionService: SessionService,
              public translationService: TranslationService) {

    let currentLang: Language[] = this.translationService.languages.filter(l => l.id === languageFactory());
    if (currentLang.length > 0) {
      this.selectedLanguage = currentLang[0];
    } else {
      this.selectedLanguage = this.translationService.languages[0];
    }
  }

  ngOnInit() {
  }

  toggleLanguageMenu() {
    this.showLanguageMenu = !this.showLanguageMenu;
  }

  setSelectedLanguage(lang: Language): void {
    this.createCookie('language', lang.id);
    this.sessionService.saveState();
    window.location.href = window.location.href + ';restore=true';
    window.location.reload();
  }


  createCookie(name: string, value: string): void {
    let date = new Date();
    date.setTime(date.getTime() + (999 * 24 * 60 * 60 * 1000));
    let expires: string = "; expires=" + date.toUTCString();
    document.cookie = name + "=" + value + expires + "; path=/";
  }

  readCookie(name: string): string {
    let nameEQ: string = name + "=";
    let ca: string[] = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c: string = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/punter-bar/punter-bar.component.ts